import React, { useContext, useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@material-ui/core";

import TicketsManager from "../../components/TicketsManager/";
import Ticket from "../../components/Ticket/";

import { i18n } from "../../translate/i18n";
import Hidden from "@material-ui/core/Hidden";
import { WhatsAppsContext } from "../../context/WhatsApp/WhatsAppsContext";

const useStyles = makeStyles((theme) => ({
  chatContainer: {
    flex: 1, 
    height: `calc(100% - 48px)`,
    overflowY: "hidden",
    backgroundColor: theme.palette.background.default,
  },

  chatPapper: { 
    display: "flex",
    height: "100%",
    backgroundColor: theme.palette.background.paper,
  },

  contactsWrapper: {
    display: "flex",
    height: "100%",
    flexDirection: "column",
    overflowY: "hidden",
  },
  contactsWrapperSmall: {
    display: "flex",
    height: "100%",
    flexDirection: "column",
    overflowY: "hidden",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  messagessWrapper: {
    display: "flex",
    height: "100%",
    flexDirection: "column",
  },
  welcomeMsg: {
    backgroundColor: theme.palette.background.paper,
    display: "flex",
    justifyContent: "space-evenly",
    alignItems: "center",
    height: "100%",
    textAlign: "center",
    borderRadius: 0,
  },
  ticketsManager: {},
  ticketsManagerClosed: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  disconnectedDialogPaper: {
    minWidth: 420,
    [theme.breakpoints.down("sm")]: {
      minWidth: "auto",
      width: "calc(100% - 32px)",
    },
  },
  disconnectedDialogTitle: {
    fontSize: 28,
    fontWeight: 700,
    color: "#9c1c1c",
  },
  disconnectedDialogText: {
    fontSize: 16,
    lineHeight: 1.5,
  },
  disconnectedDialogList: {
    marginTop: theme.spacing(2),
    paddingLeft: theme.spacing(3),
  },
}));

const Chat = () => {
  const classes = useStyles();
  const { ticketId } = useParams();
  const { whatsApps = [] } = useContext(WhatsAppsContext);
  const [disconnectModalOpen, setDisconnectModalOpen] = useState(false);
  const [lastDisconnectSignature, setLastDisconnectSignature] = useState("");

  const disconnectedInstances = useMemo(
    () =>
      whatsApps.filter((instance) =>
        ["DISCONNECTED", "TIMEOUT"].includes(instance.status)
      ),
    [whatsApps]
  );

  const disconnectSignature = useMemo(
    () =>
      disconnectedInstances
        .map((instance) => `${instance.id}:${instance.status}`)
        .sort()
        .join("|"),
    [disconnectedInstances]
  );

  useEffect(() => {
    if (!disconnectSignature) {
      setDisconnectModalOpen(false);
      setLastDisconnectSignature("");
      return;
    }

    if (disconnectSignature !== lastDisconnectSignature) {
      setDisconnectModalOpen(true);
      setLastDisconnectSignature(disconnectSignature);
    }
  }, [disconnectSignature, lastDisconnectSignature]);

  return (
    <div className={classes.chatContainer}>
      <Dialog
        open={disconnectModalOpen}
        onClose={() => setDisconnectModalOpen(false)}
        maxWidth="sm"
        fullWidth
        classes={{ paper: classes.disconnectedDialogPaper }}
      >
        <DialogTitle disableTypography>
          <Typography className={classes.disconnectedDialogTitle}>
            Instância(s) desconectada(s)
          </Typography>
        </DialogTitle>
        <DialogContent dividers>
          <Typography className={classes.disconnectedDialogText}>
            Existe pelo menos uma instância do WhatsApp desconectada na operação.
            Verifique a página de instâncias para reconectar e evitar falhas no atendimento.
          </Typography>
          <ul className={classes.disconnectedDialogList}>
            {disconnectedInstances.map((instance) => (
              <li key={instance.id}>
                <Typography className={classes.disconnectedDialogText}>
                  {instance.name} - {instance.status}
                </Typography>
              </li>
            ))}
          </ul>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setDisconnectModalOpen(false)}
            variant="contained"
            color="secondary"
          >
            Entendi
          </Button>
        </DialogActions>
      </Dialog>
      <div className={classes.chatPapper}>
        <Grid container spacing={0}>
          {/* <Grid item xs={4} className={classes.contactsWrapper}> */}
          <Grid
            item
            xs={12}
            md={4}
            className={
              ticketId ? classes.contactsWrapperSmall : classes.contactsWrapper
            }
          >
            <TicketsManager />
          </Grid>
          <Grid item xs={12} md={8} className={classes.messagessWrapper}>
            {ticketId ? (
              <>
                <Ticket />
              </>
            ) : (
              <Hidden only={["sm", "xs"]}>
                <Paper className={classes.welcomeMsg}>
                  {/* <Paper square variant="outlined" className={classes.welcomeMsg}> */}
                  <span>{i18n.t("chat.noTicketMessage")}</span>
                </Paper>
              </Hidden>
            )}
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default Chat;
